import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  fr: {
    translation: {
      nav: {
        services: "Services",
        solutions: "Solutions", 
        caseStudies: "Réalisations",
        about: "À propos",
        contact: "Contact",
        getQuote: "Devis gratuit"
      },
      hero: {
        title: "Build faster. Ship smarter. Scale securely.",
        subtitle: "IT Consulting • Web & Mobile • Automation • Digital Growth",
        tagline: "🚀 IT Consulting & Digital Solutions",
        cta: "Démarrer un projet",
        discover: "Découvrir nos services",
        stats: {
          projects: "Projets livrés",
          experience: "Années d'expérience", 
          support: "Support client"
        }
      },
      services: {
        header: "Nos Services",
        cta: "Prêt à transformer votre business ?",
        ctaButton: "Discutons de votre projet",
        description: "Nous transformons vos idées en solutions digitales performantes avec notre expertise technique et notre approche innovante.",
        consulting: {
          title: "Consulting IT",
          description: "Optimisation et accompagnement sur mesure pour votre infrastructure IT"
        },
        development: {
          title: "Développement Web & Mobile", 
          description: "Sites web et applications mobiles avec React, Flutter, Next.js"
        },
        automation: {
          title: "Automatisation & IA",
          description: "Workflows intelligents avec n8n et solutions d'IA avancées"
        },
        ecommerce: {
          title: "E-commerce & Shopify",
          description: "Boutiques en ligne performantes et solutions de vente digitale"
        },
        marketing: {
          title: "Marketing Digital",
          description: "SEO, publicité en ligne et stratégies de croissance digitale"
        },
        training: {
          title: "Formations & Workshops",
          description: "Formation en technologies, IA et automatisation pour vos équipes"
        }
      },
      caseStudies: {
        header: "Nos Réalisations",
        description: "Découvrez comment nous avons aidé nos clients à transformer leurs défis en succès digital.",
        viewMore: "Voir plus",
        cta: "Votre projet pourrait être le prochain !",
        ctaDescription: "Rejoignez nos clients satisfaits et transformez votre vision en réalité digitale avec notre expertise technique.",
        ctaButton: "Démarrer votre projet"
      },
      about: {
        header: "À propos de Winstep FZE",
        description: "Basée à Dubaï et Sharjah, Winstep FZE accompagne entreprises et indépendants dans leur transformation digitale.",
        mission: "Notre Mission",
        missionText: "Démocratiser l'accès aux technologies avancées et permettre à chaque entreprise, quelle que soit sa taille, de bénéficier d'une infrastructure IT moderne et performante pour accélérer sa croissance.",
        partner: "Votre partenaire technologique de confiance",
        description1: "Fondée au cœur des Émirats Arabes Unis, Winstep FZE combine l'expertise technique internationale avec la compréhension des besoins locaux. Nous accompagnons startups, PME et grandes entreprises dans leur transformation digitale avec une approche personnalisée et des solutions sur mesure.",
        description2: "Notre équipe multiculturelle maîtrise les dernières technologies et méthodologies agiles pour livrer des projets qui dépassent vos attentes, dans les délais et budgets convenus.",
        valuesHeader: "Nos Valeurs",
        team: "Une équipe passionnée à votre service",
        teamDescription: "Nos experts en développement, design, et stratégie digitale travaillent en synergie pour transformer vos idées en solutions concrètes et performantes.",
        stats: {
          experience: "Années d'expérience",
          projects: "Projets réalisés",
          clients: "Clients satisfaits",
          support: "Support disponible"
        },
        teamRoles: {
          developers: "Développeurs",
          consultants: "Consultants"
        },
        innovationDesc: "Nous adoptons les dernières technologies et méthodologies pour vous offrir des solutions d'avant-garde.",
        excellenceDesc: "Chaque projet est réalisé avec le plus haut niveau de qualité et d'attention aux détails.",
        securityDesc: "La sécurité de vos données et systèmes est notre priorité absolue dans tous nos développements.",
        values: {
          innovation: "Innovation",
          excellence: "Excellence", 
          security: "Sécurité"
        }
      },
      contact: {
        header: "Contactez-nous",
        getQuote: "Devis rapide",
        description: "Prêt à transformer votre vision en réalité ? Contactez-nous pour discuter de votre projet.",
        discuss: "Discutons de votre projet",
        discussDescription: "Notre équipe d'experts est à votre disposition pour analyser vos besoins et vous proposer des solutions sur mesure. Que ce soit pour un site web, une application mobile, ou une stratégie de transformation digitale complète.",
        businessHours: "Horaires d'ouverture",
        monday: "Lundi - Vendredi",
        saturday: "Samedi",
        sunday: "Dimanche", 
        emergency: "Support d'urgence",
        phoneLabel: "Téléphone",
        locationLabel: "Localisation",
        form: {
          name: "Nom complet",
          email: "Email",
          company: "Entreprise",
          phone: "Téléphone",
          service: "Service souhaité",
          message: "Message",
          send: "Envoyer le message",
          placeholder: "Décrivez votre projet en détail...",
          selectService: "Sélectionnez un service",
          companyPlaceholder: "Mon Entreprise",
          sending: "Envoi en cours..."
        },
        location: "Dubai • Sharjah",
        success: "Message envoyé avec succès!",
        error: "Erreur lors de l'envoi du message."
      },
      footer: {
        description: "Votre partenaire technologique de confiance pour la transformation digitale. Nous créons des solutions innovantes qui propulsent votre business vers le futur.",
        services: "Services",
        navigation: "Navigation",
        privacy: "Politique de confidentialité",
        crafted: "Crafted with ❤️ in Dubai",
        rights: "Tous droits réservés.",
        location: "Dubai • Sharjah • UAE"
      }
    }
  },
  en: {
    translation: {
      nav: {
        services: "Services",
        solutions: "Solutions",
        caseStudies: "Case Studies", 
        about: "About",
        contact: "Contact",
        getQuote: "Get a Quote"
      },
      hero: {
        title: "Build faster. Ship smarter. Scale securely.",
        subtitle: "IT Consulting • Web & Mobile • Automation • Digital Growth",
        tagline: "🚀 IT Consulting & Digital Solutions",
        cta: "Start a Project",
        discover: "Discover our services",
        stats: {
          projects: "Projects delivered",
          experience: "Years of experience",
          support: "Client support"
        }
      },
      services: {
        header: "Our Services", 
        cta: "Ready to transform your business?",
        ctaButton: "Let's discuss your project",
        description: "We transform your ideas into high-performance digital solutions with our technical expertise and innovative approach.",
        consulting: {
          title: "IT Consulting",
          description: "Custom optimization and guidance for your IT infrastructure"
        },
        development: {
          title: "Web & Mobile Development",
          description: "Websites and mobile apps with React, Flutter, Next.js"
        },
        automation: {
          title: "Automation & AI", 
          description: "Smart workflows with n8n and advanced AI solutions"
        },
        ecommerce: {
          title: "E-commerce & Shopify",
          description: "High-performance online stores and digital sales solutions"
        },
        marketing: {
          title: "Digital Marketing",
          description: "SEO, online advertising and digital growth strategies"
        },
        training: {
          title: "Training & Workshops",
          description: "Technology, AI and automation training for your teams"
        }
      },
      caseStudies: {
        header: "Our Case Studies",
        description: "Discover how we helped our clients transform their challenges into digital success.",
        viewMore: "View More",
        cta: "Your project could be next!",
        ctaDescription: "Join our satisfied clients and transform your vision into digital reality with our technical expertise.",
        ctaButton: "Start your project"
      },
      about: {
        header: "About Winstep FZE",
        description: "Based in Dubai and Sharjah, Winstep FZE helps businesses and freelancers in their digital transformation.",
        mission: "Our Mission",
        missionText: "Democratize access to advanced technologies and enable every company, regardless of size, to benefit from modern and high-performance IT infrastructure to accelerate their growth.",
        partner: "Your trusted technology partner",
        description1: "Founded in the heart of the United Arab Emirates, Winstep FZE combines international technical expertise with understanding of local needs. We support startups, SMEs and large companies in their digital transformation with a personalized approach and tailor-made solutions.",
        description2: "Our multicultural team masters the latest technologies and agile methodologies to deliver projects that exceed your expectations, within agreed deadlines and budgets.",
        valuesHeader: "Our Values",
        team: "A passionate team at your service",
        teamDescription: "Our experts in development, design, and digital strategy work in synergy to transform your ideas into concrete and efficient solutions.",
        stats: {
          experience: "Years of experience",
          projects: "Projects completed",
          clients: "Satisfied clients",
          support: "Support available"
        },
        teamRoles: {
          developers: "Developers",
          consultants: "Consultants"
        },
        innovationDesc: "We adopt the latest technologies and methodologies to offer you cutting-edge solutions.",
        excellenceDesc: "Every project is carried out with the highest level of quality and attention to detail.",
        securityDesc: "The security of your data and systems is our absolute priority in all our developments.",
        values: {
          innovation: "Innovation",
          excellence: "Excellence",
          security: "Security"
        }
      },
      contact: {
        header: "Contact Us",
        getQuote: "Quick Quote",
        description: "Ready to transform your vision into reality? Contact us to discuss your project.",
        discuss: "Let's discuss your project",
        discussDescription: "Our team of experts is at your disposal to analyze your needs and offer you tailor-made solutions. Whether for a website, mobile application, or complete digital transformation strategy.",
        businessHours: "Business Hours",
        monday: "Monday - Friday",
        saturday: "Saturday",
        sunday: "Sunday", 
        emergency: "Emergency support",
        phoneLabel: "Phone",
        locationLabel: "Location",
        form: {
          name: "Full Name",
          email: "Email",
          company: "Company",
          phone: "Phone",
          service: "Desired Service",
          message: "Message", 
          send: "Send Message",
          placeholder: "Describe your project in detail...",
          selectService: "Select a service",
          companyPlaceholder: "My Company",
          sending: "Sending..."
        },
        location: "Dubai • Sharjah",
        success: "Message sent successfully!",
        error: "Error sending message."
      },
      footer: {
        description: "Your trusted technology partner for digital transformation. We create innovative solutions that propel your business towards the future.",
        services: "Services",
        navigation: "Navigation",
        privacy: "Privacy Policy",
        crafted: "Crafted with ❤️ in Dubai",
        rights: "All rights reserved.",
        location: "Dubai • Sharjah • UAE"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n;